// /speaking: the top of the real funnel. Talks, formats and stage credentials,
// all factual: the Agile Alliance board years, the people trained, the
// community work. Booking a talk is a lane on /talk.

const speakingContent = {
  'en-US': {
    seo: {
      title: 'Talks and Keynotes | Samuel Crescencio | Lean it 101',
      description:
        'Keynotes and executive sessions on the Lean Pyramid, agent-era software delivery, and strategy that survives contact with execution.',
    },
    hero: {
      kicker: 'Speaking',
      headline: 'Talks that come from the floor, delivered from the stage.',
      body: 'Samuel Crescencio speaks about what the practice actually does: directing AI agents without surrendering judgment, strategy that reaches Monday morning, and the operating model behind both. Every talk carries material from real engagements.',
    },
    talks: {
      kicker: 'Current talks',
      items: [
        {
          name: 'The Lean Pyramid: who does the work in the agent era?',
          line: 'The operating model for companies deciding how much of themselves to hand to AI agents, and how humans stay in charge.',
          audience: 'Executives and tech leadership',
          length: '45 to 60 min keynote',
        },
        {
          name: 'Directing agents without surrendering judgment',
          line: 'What changes in software engineering when agents do the heavy lifting: verification, flow, and the vault of living standards.',
          audience: 'Engineering organizations',
          length: '60 min talk or half-day workshop',
        },
        {
          name: 'Strategy that survives contact with execution',
          line: 'Hoshin Kanri in technology companies: from annual objectives to a weekly rhythm the teams actually keep.',
          audience: 'Boards and executive teams',
          length: '45 min keynote or executive briefing',
        },
      ],
    },
    proof: {
      kicker: 'Stage record',
      items: [
        'Five years on the board of directors of the Agile Alliance',
        'More than 3.000 people trained in Lean, Agile and engineering practice',
        'Speaker at TDC and international software conferences',
        'Host of a chapter of a global engineering leadership community',
      ],
    },
    cta: { label: 'Invite Samuel to speak', sub: 'Answered personally, within one business day.' },
  },
  'pt-BR': {
    seo: {
      title: 'Palestras e Keynotes | Samuel Crescencio | Lean it 101',
      description:
        'Keynotes e sessões executivas sobre a Pirâmide Lean, desenvolvimento de software na era dos agentes, e estratégia que sobrevive ao contato com a execução.',
    },
    hero: {
      kicker: 'Palestras',
      headline: 'Palestras que vêm do chão de fábrica, entregues do palco.',
      body: 'Samuel Crescencio fala sobre o que a prática realmente faz: dirigir agentes de IA sem abrir mão do julgamento, estratégia que chega na segunda-feira, e o modelo operacional por trás dos dois. Toda palestra carrega material de engajamentos reais.',
    },
    talks: {
      kicker: 'Palestras atuais',
      items: [
        {
          name: 'A Pirâmide Lean: quem faz o trabalho na era dos agentes?',
          line: 'O modelo operacional para empresas decidindo quanto de si entregar a agentes de IA, e como humanos permanecem no comando.',
          audience: 'Executivos e liderança de tecnologia',
          length: 'Keynote de 45 a 60 min',
        },
        {
          name: 'Dirigindo agentes sem abrir mão do julgamento',
          line: 'O que muda na engenharia de software quando agentes fazem o trabalho pesado: verificação, fluxo, e o vault de padrões vivos.',
          audience: 'Organizações de engenharia',
          length: 'Palestra de 60 min ou workshop de meio dia',
        },
        {
          name: 'Estratégia que sobrevive ao contato com a execução',
          line: 'Hoshin Kanri em empresas de tecnologia: dos objetivos anuais a um ritmo semanal que os times de fato mantêm.',
          audience: 'Conselhos e times executivos',
          length: 'Keynote de 45 min ou briefing executivo',
        },
      ],
    },
    proof: {
      kicker: 'Histórico de palco',
      items: [
        'Cinco anos no board of directors da Agile Alliance',
        'Mais de 3.000 pessoas treinadas em Lean, Agile e práticas de engenharia',
        'Palestrante no TDC e em conferências internacionais de software',
        'Host de um capítulo de uma comunidade global de liderança em engenharia',
      ],
    },
    cta: { label: 'Convidar o Samuel para palestrar', sub: 'Respondido pessoalmente, em até um dia útil.' },
  },
  es: {
    seo: {
      title: 'Charlas y Keynotes | Samuel Crescencio | Lean it 101',
      description:
        'Keynotes y sesiones ejecutivas sobre la Pirámide Lean, el desarrollo de software en la era de los agentes, y estrategia que sobrevive al contacto con la ejecución.',
    },
    hero: {
      kicker: 'Charlas',
      headline: 'Charlas que vienen del piso, entregadas desde el escenario.',
      body: 'Samuel Crescencio habla de lo que la práctica realmente hace: dirigir agentes de IA sin renunciar al juicio, estrategia que llega al lunes, y el modelo operativo detrás de ambos. Cada charla lleva material de compromisos reales.',
    },
    talks: {
      kicker: 'Charlas actuales',
      items: [
        {
          name: 'La Pirámide Lean: ¿quién hace el trabajo en la era de los agentes?',
          line: 'El modelo operativo para empresas que deciden cuánto de sí mismas entregar a agentes de IA, y cómo los humanos siguen al mando.',
          audience: 'Ejecutivos y liderazgo tecnológico',
          length: 'Keynote de 45 a 60 min',
        },
        {
          name: 'Dirigiendo agentes sin renunciar al juicio',
          line: 'Qué cambia en la ingeniería de software cuando los agentes hacen el trabajo pesado: verificación, flujo, y el vault de estándares vivos.',
          audience: 'Organizaciones de ingeniería',
          length: 'Charla de 60 min o workshop de medio día',
        },
        {
          name: 'Estrategia que sobrevive al contacto con la ejecución',
          line: 'Hoshin Kanri en empresas de tecnología: de los objetivos anuales a un ritmo semanal que los equipos realmente mantienen.',
          audience: 'Consejos y equipos ejecutivos',
          length: 'Keynote de 45 min o briefing ejecutivo',
        },
      ],
    },
    proof: {
      kicker: 'Historial de escenario',
      items: [
        'Cinco años en el board of directors de la Agile Alliance',
        'Más de 3.000 personas formadas en Lean, Agile y prácticas de ingeniería',
        'Ponente en TDC y en conferencias internacionales de software',
        'Host de un capítulo de una comunidad global de liderazgo en ingeniería',
      ],
    },
    cta: { label: 'Invitar a Samuel a hablar', sub: 'Respondido personalmente, dentro de un día hábil.' },
  },
}

const normalize = (language) => {
  if (!language) return 'en-US'
  const lower = language.toLowerCase()
  if (lower.startsWith('pt')) return 'pt-BR'
  if (lower.startsWith('es')) return 'es'
  return 'en-US'
}

export const getSpeakingContent = (language) => speakingContent[normalize(language)]
export default speakingContent
